import Account from '../../../models/account/Account';
import { Client } from '../../../models/client/Client';
import { UsageMediumType } from '../../../models/client/UsageMediumType';
import EWalletConst from '../../consts/EWalletConst';

const EWalletUtility = {
    ePurseAmount(account?: Account, client?: Client): number {
        if (client?.usageMediumType === UsageMediumType.PhysicalCard)
            return client.ePurseAmount || 0;

        return account?.ePurseAmount || 0;
    },
    getPredefinedValues(): number[] {
        return EWalletConst.PredefinedValues;
    }
}

export default EWalletUtility;
